import VersionNotification from './VersionNotification'
export default class VersionNotificationList extends VersionNotification {
  static entity = 'versionnotificationlist'
}
